const Styles = {
    'ResultGroup': 'ResultGroup_ResultGroup--1daba66b',
    'ResultsContainer': 'ResultGroup_ResultsContainer--e618d1e0'
};

export default Styles;